export function normalizeOptions(options = []) {
  return options.map((opt) => {
    const match = opt.match(/^([A-Z])\)\s*(.*)$/);
    if (!match) {
      return { id: opt, text: opt };
    }
    return {
      id: match[1],
      text: match[2],
    };
  });
}